export enum CopilotTeachingPopoverAnchorID {
    MetaOSCopilotButton = "0",
    CommandCenterCopilotButton = "1",
    HeaderSummarizeButton = "2",
    CalendarCopilotSearchToggle = "3",
    MailCopilotSearchToggle = "4",
    ComposeFormCoAuthoringGhostText = "6",
    CalendarCopilotSearchEntryPoint = "7",
    MailCopilotSearchEntryPoint = "8"
}
